import React from 'react';
import {GoogleMap, LoadScript, Marker} from '@react-google-maps/api';

function BranchMap({lat, lng, setGetLocation}) {
    const containerStyle = {
        width: '100%',
        height: '300px'
    };

    function handleSelect(ev) {
        // setLat(ev.latLng.lat());
        // setLng(ev.latLng.lng());
        // console.log('lat', ev.latLng.lat())
        // console.log('lng', ev.latLng.lng())
        setGetLocation({lat: ev.latLng.lat(), lng: ev.latLng.lng()});
    }

    const center = {
        lat,
        lng
    }

    console.log(center);

    return (
        <div className="mb-3">
            <LoadScript
                googleMapsApiKey="AIzaSyCWVEEUvpORP-mDppGgcv53yfv_aBxqSk8"
            >
                <GoogleMap
                    mapContainerStyle={containerStyle}
                    center={center}
                    zoom={10}

                >
                    <Marker
                        onDragEnd={handleSelect}
                        draggable={true}
                        position={center}
                    />
                </GoogleMap>
            </LoadScript>
        </div>
    );
}

export default React.memo(BranchMap)